/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarAttachmentsDtoFromJSON, CarAttachmentsDtoToJSON, CarMainDtoFromJSON, CarMainDtoToJSON, CarNotesDtoFromJSON, CarNotesDtoToJSON, CarPhotosDtoFromJSON, CarPhotosDtoToJSON, CarServiceDtoFromJSON, CarServiceDtoToJSON, CarTechDtoFromJSON, CarTechDtoToJSON, CarTireSectionDtoFromJSON, CarTireSectionDtoToJSON, GarageSpotCarEditDtoFromJSON, GarageSpotCarEditDtoToJSON, } from './';
export function CarEditDtoFromJSON(json) {
    return CarEditDtoFromJSONTyped(json, false);
}
export function CarEditDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'main': !exists(json, 'main') ? undefined : CarMainDtoFromJSON(json['main']),
        'photos': !exists(json, 'photos') ? undefined : CarPhotosDtoFromJSON(json['photos']),
        'tech': !exists(json, 'tech') ? undefined : CarTechDtoFromJSON(json['tech']),
        'service': !exists(json, 'service') ? undefined : CarServiceDtoFromJSON(json['service']),
        'tires': !exists(json, 'tires') ? undefined : CarTireSectionDtoFromJSON(json['tires']),
        'notes': !exists(json, 'notes') ? undefined : CarNotesDtoFromJSON(json['notes']),
        'attachments': !exists(json, 'attachments') ? undefined : CarAttachmentsDtoFromJSON(json['attachments']),
        'garageSpot': !exists(json, 'garageSpot') ? undefined : GarageSpotCarEditDtoFromJSON(json['garageSpot']),
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
    };
}
export function CarEditDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'main': CarMainDtoToJSON(value.main),
        'photos': CarPhotosDtoToJSON(value.photos),
        'tech': CarTechDtoToJSON(value.tech),
        'service': CarServiceDtoToJSON(value.service),
        'tires': CarTireSectionDtoToJSON(value.tires),
        'notes': CarNotesDtoToJSON(value.notes),
        'attachments': CarAttachmentsDtoToJSON(value.attachments),
        'garageSpot': GarageSpotCarEditDtoToJSON(value.garageSpot),
        'carId': value.carId,
    };
}
